import React from "react";
import Agent from "./agent.jsx";
export const getbarbers = async (shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.getAtt(
    `/barber/GetAllPublicStaff?BarbershopId=${shopId}`,
    null
  );
};
export const getAllbarbers = async (shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const { requests } = Agent();
  return await requests.get(`/barber/GetAllStaff/${shopId}`, token, shopId);
};
export const createBarber = async (barber, shopId) => {
  try {
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();
    return await requests.postForm(`/Barber/`, barber, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateBarber = async (barber, shopId) => {
  try {
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();
    return await requests.putForm(`/Barber/`, barber, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const deleteBarber = async (barberId, shopId) => {
  try {
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();
    return await requests.del(`/Barber/${barberId}`, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const getAvailableTimeSlots = async (
  barberId,
  shopId,
  date,
  requiredMinutes
) => {
  try {
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();

    return await requests.get(
      `/Barber/AvailableTimeSlot?barber=${barberId}&shop=${shopId}&date=${date}&requiredMinutes=${requiredMinutes}`,
      token,
      shopId
    );
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
